<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Backup Database 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="5">
            <b-input-group >
                <b-input-group-prepend><label>Platform(OS)</label></b-input-group-prepend>
                <b-form-select class="input-group-text" v-model="model.platform" :plain="true" :options="os" disabled></b-form-select>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Database Location</label></b-input-group-prepend>
                <b-form-input v-model="model.datadir" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Database Name</label></b-input-group-prepend>
                <b-form-input v-model="model.db_name" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Backup Name</label></b-input-group-prepend>
                <b-form-input v-model="model.backup_name" readonly></b-form-input>
            </b-input-group>

            <b-row class="justify-content-center mt-4">
                <b-button class="btn btn-success" @click="processConfirm()" > <i class="fa fa-play"></i> Process</b-button>
              </b-row>
        </b-col>
        <b-col lg="7">
            <h3>List Backup</h3>
            <div v-for="backup in databackup" class="backup-box" :key="backup.date">
                <div class="backup-text">{{backup.text}}</div>
                <div class="backup-row">
                    <div class="backup-date">backup at: {{backup.date}}</div>
                    <div class="backup-user">, by {{backup.username}}</div>
                </div>
                <div class="backup-row action">
                    <div>
                            <a href="javascript:void(0)" class="text-info" @click="download(backup)">
                                <i class="fa fa-cloud-download"></i> Download
                            </a>
                    </div>
                    <div>
                            <a href="javascript:void(0)" class="text-danger" @click="remove(backup)">
                                <i class="fa fa-trash"></i> Remove
                            </a>             
                    </div>
                </div>                        
            </div>

        </b-col>
      </b-row>
    </b-card>
      <b-modal v-model="showDelConfirm" title="Delete Record Confirmation" :centered="true" @ok="deleteBackup">
        <p class="mb-1">1 Backup is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showProcessConfirm" title="Backup Process Confirmation" :centered="true" @ok="processBackup">
        <p class="mb-1">Backup Process will be started, it will consume your Storage capacity</p>
        <p class="font-weight-bold m-0 text-danger">Are you Sure ?</p>
      </b-modal>
      <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>

<style lang="scss">
    .backup-box {
        margin-bottom: 10px;
        .backup-text {
            font-size: 14px;
            font-weight: bold;
            font-style: italic;
        }       
        .backup-row {
            div {
                display: inline-block;
                font-size: 12px;
                font-style: italic;
                a {
                      margin-right: 10px;
                  }        
                a:hover {
                        text-decoration: none;
                    }                          
            }
        } 
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import backup from "../../apis/backup";

toastr.init();

export default {
  data() {
    return {
      showDelConfirm: false,
      showProcessConfirm: false,
      isLoading:false,
      model:{},
      databackup:{}
    };
  },
  components:{Loading},
  created: async function(){
      this.os= [
          { value: 'linux', text: 'Linux' },
          { value: 'win32', text: 'Windows' },
          { value: 'darwin', text: 'Mac OS' },
      ];
    const result = await backup.init();
    for (let key in key) {
        if (key == 'backup') {
            this.databackup = result[key];
        } else {
            this.model[key] = result[key];
        }
    };
    this.model.backup_name = `${(this.model.db_name).toUpperCase() + moment().format('_YYMMDD_HHMMSS')}.sql`

  },
  methods: {
    remove(item) {
      this.bak = item;
      this.showDelConfirm = true;
    },
    deleteBackup: async function() {
      const result = await backup.remove(this.bak);
      for (let key in result) {
          if (key == 'backup') {
              this.databackup = result[key];
          }
      };
      // this.refresh();
    },
    processConfirm() {
      this.showProcessConfirm = true;
    },
    processBackup: async function() {
      try {
          this.isLoading=true;
          const result = await backup.process(this.model);
          for (let key in result) {
              if (key == 'backup') {
                  this.databackup = result[key];
              }
          };

          toastr.success("Complete successfully", "Backup Process");
          this.isLoading=false;      
        } catch (error) {
          this.isLoading=false;      
            console.log('error : ', error);
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },
    download: async function(item) {
      try {
          this.isLoading=true;
          await backup.download(item);
          // toastr.success("Complete successfully", "Backup Process");
          this.isLoading=false;      
        } catch (error) {
          this.isLoading=false;      
            console.log('error : ', error);
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },
    close(){
      router.push("home");
    },    
  }
};
</script>
